// Home.jsx
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
// import EnvelopeUpgrade from "./partials/EnvelopeUpgrade";
// import UseTemplate from "./UseTemplate";
import { Lang } from "../../lang";
import Utils from "../../utils";
import useDocumentCounts from "./Envelope/Manage/useDocumentCounts";
import { envelopeLeft } from "../../services/CommonService";

function Home() {
    // Meta-tag & title handling
    useEffect(() => {
        document.title = Lang.homepage_title;

        const metaTags = document.getElementsByTagName("META");

        const setMetaContent = (index, content) => {
            if (metaTags[index]) {
                metaTags[index].content = content;
            }
        };

        setMetaContent(4, Lang.homepage_meta_desc);
        setMetaContent(5, Lang.homepage_meta_keyword);
    }, []);

    // User & document counts
    const userData = Utils.loginUserData() || {};
    const userEmail = userData.email || "";
    const userId = userData.id ?? null;

    const [dataParams] = useState({});
    const {
        counts: { totalFiles = 0, totalInProgress = 0, totalCompleted = 0 },
    } = useDocumentCounts({ userEmail, userId, dataParams });

    // Plan & envelope balance
    const [totalEnvelope, setTotalEnvelope] = useState(0);
    const [planName, setPlanName] = useState("Free Trial");

    useEffect(() => {
        const fetchEnvelopeData = async () => {
            try {
                const response = await envelopeLeft({});
                const { plan_name, total_envelope } = response.data.data;

                setPlanName(plan_name);
                setTotalEnvelope(total_envelope);
            } catch (err) {
                console.error("Failed to fetch envelope data:", err);
            }
        };

        fetchEnvelopeData();
    }, []);

    // Navigation helpers
    const navigate = useNavigate();

    const goTo = useCallback(
        (path, preventDefault = true) =>
            (e) => {
                if (preventDefault && e?.preventDefault) e.preventDefault();
                navigate(path);
            },
        [navigate]
    );

    // Template off-canvas (optional)
    const [isUseTemplate, setIsUseTemplate] = useState(false); // Still here if you later re-enable <UseTemplate />

    return (
        <>
            <section
                className="docusafe_wrapper client_home section_bg_color landing_section"
                style={{ minHeight: "calc(100vh - 54.5px)" }}
            >
                <div className="container">
                    <h2 className="home_title">Create a Sleeve</h2>
                    <p className="main_text">{Lang.home_text}</p>

                    {/* First row*/}
                    <div className="row g-4 mb-4">
                        {/* Start from scratch */}
                        <div
                            className="col-md-6 col-lg-6 col-xl-3 col-sm-12 cur-pointer"
                            role="button"
                            tabIndex={0}
                            onClick={goTo("/client-portal/sleeve", false)}
                            onKeyDown={(e) => e.key === "Enter" && goTo("/client-portal/sleeve")(e)}
                            aria-label="Start a sleeve from scratch"
                        >
                            <div className="start-scratch-card">
                                <div className="start-scratch-icon">
                                    {/* Plus icon */}
                                    <svg
                                        width="36"
                                        height="36"
                                        viewBox="0 0 36 36"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect width="36" height="36" rx="10" fill="#9747FF" />
                                        <path
                                            d="M18 11V25"
                                            stroke="white"
                                            strokeWidth="2.5"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            d="M11 18H25"
                                            stroke="white"
                                            strokeWidth="2.5"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </div>
                                <div className="start-scratch-content">
                                    <h3 className="start-scratch-title">Start From Scratch</h3>
                                    <p className="start-scratch-desc">
                                        A blank Sleeve for collecting a list of Documents.
                                    </p>
                                    <button
                                        className="start-scratch-btn"
                                        type="button"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="right"
                                        data-bs-original-title={Lang.home_start_scratch}
                                        onClick={goTo("/client-portal/sleeve")}
                                    >
                                        Start Now
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Use Template */}
                        <div
                            className="col-md-6 col-lg-6 col-xl-3 col-sm-12 cur-pointer"
                            role="button"
                            tabIndex={0}
                            data-bs-toggle="offcanvas"
                            data-bs-target="#useTemplate"
                            onClick={(e) => {
                                e.preventDefault();
                                setIsUseTemplate(true);
                            }}
                            onKeyDown={(e) =>
                                e.key === "Enter" && setIsUseTemplate(true)
                            }
                            aria-label="Create sleeve from template"
                        >
                            <div className="start-scratch-card">
                                <div className="start-scratch-icon">
                                    {/* Document icon */}
                                    <svg width="24" height="24" fill="white" viewBox="0 0 24 24">
                                        <rect
                                            x="6"
                                            y="3"
                                            width="12"
                                            height="18"
                                            rx="2"
                                            fill="none"
                                            stroke="white"
                                            strokeWidth="2"
                                        />
                                        <path
                                            d="M9 7h6M9 11h6M9 15h3"
                                            stroke="white"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </div>
                                <div
                                    className="start-scratch-content"
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#useTemplate"
                                >
                                    <h3 className="start-scratch-title">Use Template</h3>
                                    <p className="start-scratch-desc">
                                        Premade Template for collecting a list of Documents
                                    </p>
                                    <button
                                        className="start-scratch-btn"
                                        type="button"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="right"
                                        data-bs-original-title={Lang.home_use_template}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setIsUseTemplate(true);
                                        }}
                                    >
                                        Start Now
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Sleeves Files */}
                        <div
                            className="col-md-6 col-lg-6 col-xl-3 col-sm-12 cur-pointer"
                            role="button"
                            tabIndex={0}
                            onClick={goTo("/manage/files", false)}
                            onKeyDown={(e) => e.key === "Enter" && goTo("/manage/files")(e)}
                            aria-label="View sleeves files"
                        >
                            <div className="my-files-card">
                                <div className="start-scratch-icon">
                                    {/* Folder icon */}
                                    <svg
                                        width="36"
                                        height="36"
                                        viewBox="0 0 36 36"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect width="36" height="36" rx="10" fill="#9747FF" />
                                        <path
                                            d="M10 24C9 24 9 23 9 23V13C9 12 10 12 10 12H15L16.5 14H26C27 14 27 15 27 15V23C27 24 26 24 26 24H10Z"
                                            fill="white"
                                        />
                                        <rect
                                            x="13"
                                            y="16"
                                            width="10"
                                            height="2"
                                            rx="1"
                                            fill="#D1B3FF"
                                        />
                                        <rect
                                            x="13"
                                            y="19"
                                            width="7"
                                            height="2"
                                            rx="1"
                                            fill="#D1B3FF"
                                        />
                                    </svg>
                                </div>
                                <div className="start-scratch-content">
                                    <div className="my-sleeves-title-row">
                                        <h3 className="start-scratch-title">Sleeves Files</h3>
                                    </div>
                                    <p className="start-scratch-desc">
                                        View and manage all your created sleeves.
                                    </p>
                                    <button
                                        className="start-scratch-btn view-sleeves-btn"
                                        onClick={goTo("/manage/files")}
                                    >
                                        View
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Plan status */}
                        <div
                            className="col-md-6 col-lg-6 col-xl-3 col-sm-12 cur-pointer"
                            role="button"
                            tabIndex={0}
                            onClick={goTo("/billing/pricing", false)}
                            onKeyDown={(e) =>
                                e.key === "Enter" && goTo("/billing/pricing")(e)
                            }
                            aria-label="Upgrade plan"
                        >
                            <div className="pro-plan-card">
                                <div className="d-flex justify-content-between align-items-center ">
                                    <span className="pro-plan-title">
                                        {planName} Plan Status
                                    </span>
                                    <span className="pro-plan-icon">
                                        {/* Analytics icon */}
                                        <svg
                                            width="20"
                                            height="20"
                                            fill="white"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M3 17h2v-7H3v7zm4 0h2v-3H7v3zm4 0h2v-10h-2v10zm4 0h2v-5h-2v5zm4 0h2v-2h-2v2z" />
                                        </svg>
                                    </span>
                                </div>
                                <div className="pro-plan-count mb-0">{totalEnvelope}</div>
                                <div className="pro-plan-label">Sleeves Left</div>
                                <button
                                    className="pro-plan-upgrade-btn"
                                    onClick={goTo("/billing/pricing")}
                                >
                                    Upgrade
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Second row*/}
                    <div className="row g-4">
                        {/* My Files */}
                        <div
                            className="col-md-6 col-lg-6 col-xl-3 col-sm-12 cur-pointer"
                            role="button"
                            tabIndex={0}
                            onClick={goTo("/manage/my-files", false)}
                            onKeyDown={(e) =>
                                e.key === "Enter" && goTo("/manage/my-files")(e)
                            }
                            aria-label="Browse files"
                        >
                            <div className="my-files-card">
                                <div className="start-scratch-icon">
                                    {/* Star icon */}
                                    <svg
                                        width="36"
                                        height="36"
                                        viewBox="0 0 36 36"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect width="36" height="36" rx="10" fill="#9747FF" />
                                        <path
                                            d="M18 25.5L10.7553 29.4721L12.2553 21.2361L6.51062 15.5279L14.8777 14.2639L18 7.5L21.1223 14.2639L29.4894 15.5279L23.7447 21.2361L25.2447 29.4721L18 25.5Z"
                                            stroke="white"
                                            strokeWidth="2"
                                            fill="none"
                                        />
                                    </svg>
                                </div>
                                <div className="start-scratch-content">
                                    <h3 className="start-scratch-title">My Files</h3>
                                    <p className="start-scratch-desc">
                                        Access and organize all your uploaded documents.
                                    </p>
                                    <button
                                        className="start-scratch-btn browse-files-btn"
                                        onClick={goTo("/manage/my-files")}
                                    >
                                        Browse Files
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Dashboard counts */}
                        <div className="col-md-6 col-lg-6 col-xl-3 col-sm-12"
                            onClick={goTo("/client-portal/certificate", false)}
                            onKeyDown={(e) =>
                                e.key === "Enter" && goTo("/client-portal/certificate")(e)
                            }>
                            <div className="dashboard-card-content">
                                <div className="dashboard-card-header">
                                    <div className="start-scratch-icon">
                                        {/* Clock icon */}
                                        <svg
                                            width="24"
                                            height="24"
                                            fill="white"
                                            viewBox="0 0 24 24"
                                        >
                                            <circle
                                                cx="12"
                                                cy="12"
                                                r="10"
                                                stroke="white"
                                                strokeWidth="2"
                                                fill="none"
                                            />
                                            <path
                                                d="M12 7v5l3 3"
                                                stroke="white"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div>
                                    <div className="dashboard-card-title">Certificate</div>
                                </div>
                                {/* <div>
                                    <div className="dashboard-card-number">{totalInProgress}</div>
                                    <div className="dashboard-card-title">Active Sleeves</div>
                                </div>
                                <div>
                                    <div className="dashboard-card-number">{totalCompleted}</div>
                                    <div className="dashboard-card-title">Total Completed</div>
                                </div> */}
                            </div>
                        </div>

                        {/* Smart questionnaire */}
                        <div
                            className="col-md-6 col-lg-6 col-xl-3 col-sm-12 cur-pointer"
                            role="button"
                            tabIndex={0}
                            onClick={goTo("/client-portal/questionnaire", false)}
                            onKeyDown={(e) =>
                                e.key === "Enter" &&
                                goTo("/client-portal/questionnaire")(e)
                            }
                            aria-label="Start questionnaire"
                        >
                            <div className="start-scratch-card">
                                <div className="start-scratch-icon">
                                    {/* Plus icon */}
                                    <svg
                                        width="36"
                                        height="36"
                                        viewBox="0 0 36 36"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect width="36" height="36" rx="10" fill="#9747FF" />
                                        <path
                                            d="M18 11V25"
                                            stroke="white"
                                            strokeWidth="2.5"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            d="M11 18H25"
                                            stroke="white"
                                            strokeWidth="2.5"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </div>
                                <div className="start-scratch-content">
                                    <h3 className="start-scratch-title">Questionnaire</h3>
                                    <p className="start-scratch-desc">
                                        Create Questionnaire.
                                    </p>
                                    <button
                                        className="start-scratch-btn"
                                        type="button"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="right"
                                        onClick={goTo("/client-portal/questionnaire")}
                                    >
                                        Start Now
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Manage questionnaire */}
                        <div
                            className="col-md-6 col-lg-6 col-xl-3 col-sm-12 cur-pointer"
                            role="button"
                            tabIndex={0}
                            onClick={goTo(
                                "/client-portal/questionnaire/manage",
                                false
                            )}
                            onKeyDown={(e) =>
                                e.key === "Enter" &&
                                goTo("/client-portal/questionnaire/manage")(e)
                            }
                            aria-label="Manage smart questionnaire"
                        >
                            <div className="my-files-card">
                                <div className="start-scratch-icon">
                                    {/* List icon */}
                                    <svg
                                        width="36"
                                        height="36"
                                        viewBox="0 0 36 36"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect width="36" height="36" rx="10" fill="#9747FF" />
                                        <rect
                                            x="11"
                                            y="13"
                                            width="14"
                                            height="2"
                                            rx="1"
                                            fill="white"
                                        />
                                        <rect
                                            x="11"
                                            y="17"
                                            width="10"
                                            height="2"
                                            rx="1"
                                            fill="white"
                                        />
                                        <rect
                                            x="11"
                                            y="21"
                                            width="7"
                                            height="2"
                                            rx="1"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                                <div className="start-scratch-content">
                                    <h3 className="start-scratch-title">Manage Questionnaire</h3>
                                    <p className="start-scratch-desc">
                                        View and manage all your created Questionnaire.
                                    </p>
                                    <button
                                        className="start-scratch-btn browse-files-btn"
                                        onClick={goTo("/client-portal/questionnaire/manage")}
                                    >
                                        Manage
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ---------------------------------------------------------------------
         Template offcanvas (uncomment when you restore the component)
      --------------------------------------------------------------------- */}
            {/* <UseTemplate
        isUseTemplate={isUseTemplate}
        setIsUseTemplate={setIsUseTemplate}
      /> */}
        </>
    );
}

export default Home;
